<div class="nar">
  <div class="nar-title">
    {{ TranslationKeys.GeneralNotAvailableReason | translate }}
  </div>
  <span class="nar-date">{{ updateDate(selectedRequest.startTime) }}</span>

  <nimbus-form-wrapper [formGroup]="form">
    <nimbus-form-row>
      <div class="nar-button-fields" #narButtonFields>
        @for (x of notAvailableReasons; track x) {
          <div class="nar-button-field" id="{{ x.reasonId }}">
            <button
              [disabled]="isProcessingNar"
              nimbusSecondaryButton
              (click)="selectNar(x.reasonId)"
              class="nar-button"
              [ngClass]="{ selected: selectedOption && x.reasonId === selectedOption.reasonId }"
            >
              <nimbus-tooltip [text]="x.name"></nimbus-tooltip>
              {{ x.name }}
            </button>
          </div>
        }
      </div>
    </nimbus-form-row>
    <nimbus-form-row>
      <nimbus-form-control>
        <mat-form-field appearance="outline">
          <mat-label> {{ TranslationKeys.NotAvailableReasonSelectOtherReason | translate }} </mat-label>
          <input matInput [formControl]="control" [matAutocomplete]="auto" autocomplete="off" [disabled]="isProcessingNar" />
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
            @for (option of filteredOptions | async; track option) {
              <mat-option [id]="option.reasonId" [value]="option.name" class="user-autocomplete-mat-option">
                <div class="mat-option-user-item">
                  <div class="user-information">
                    <div class="user-name">
                      <nimbus-tooltip [text]="option.name"></nimbus-tooltip>
                      {{ option.name }}
                    </div>
                  </div>
                </div>
              </mat-option>
            }
          </mat-autocomplete>
          <ng-container matSuffix>
            <ng-content></ng-content>
          </ng-container>
          @if (!control.value) {
            <i matSuffix class="cursor-pointer" [nimbusIcon]="icons.CHEVRON_DOWN_LIGHT"></i>
          }
          @if (control.value) {
            <i matSuffix class="cursor-pointer" [nimbusIcon]="icons.CLOSE_LIGHT" (click)="onClearValueClick()"></i>
          }
        </mat-form-field>
      </nimbus-form-control>
    </nimbus-form-row>
  </nimbus-form-wrapper>
</div>

<div nimbusMaterialButtonsRow class="nar-buttons">
  <div>
    <button nimbusSecondaryButton (click)="cancel()" [disabled]="isProcessingNar">
      {{ TranslationKeys.GeneralCancel | translate }}
    </button>
  </div>
  <div>
    <button nimbusPrimaryButton (click)="submit()" [disabled]="!selectedOption || isProcessingNar">
      {{ TranslationKeys.GeneralSubmit | translate }}
    </button>
  </div>
</div>
